import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-ink-800 px-4 py-10 sm:px-6 sm:py-14" data-id="element-48" data-mp="1blka2yumh30n">
      <div className="mx-auto max-w-2xl" data-id="element-49" data-mp="1gjbz9l3vub15">
        <h2 className="text-center text-lg font-extrabold uppercase text-white sm:text-2xl" data-id="element-50" data-mp="1gketo30eyvlt">
          Lo que más nos preguntan
        </h2>

        <ul className="mt-6 space-y-2" data-id="element-51" data-mp="28arw07z5le53">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.question} className="overflow-hidden rounded-xl border border-white/10 bg-ink-700" data-id="element-52" data-mp="1uili6sjh3j8t" data-mpi={index}>
                <h3 data-id="element-53" data-mp="2n8bvizda6h3v">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left text-[13px] font-bold text-white transition-colors duration-150 hover:text-gold-400 sm:text-sm" data-id="element-54" data-mp="2n7sb9c05rgmo">
                    {faq.question}
                    <span aria-hidden="true" className="shrink-0 text-gold-500" data-id="element-55" data-mp="19tvavtw5tap8">
                      {isOpen ? <MinusIcon className="h-4 w-4" data-id="element-56" data-mp="1oihyeivxx8rj" /> : <PlusIcon className="h-4 w-4" data-id="element-57" data-mp="1jkpzv60sioed" />}
                    </span>
                  </button>
                </h3>
                {isOpen && <div id={`faq-panel-${index}`} className="border-t border-white/10 px-4 py-4 text-[13px] leading-relaxed text-neutral-300" data-id="element-58" data-mp="1skv2z3yyb0mq">
                    {faq.answer}
                  </div>}
              </li>;
        })}
        </ul>
      </div>
    </section>;
}